import { Utils } from '../../../../../../../core/utils/utils';
import { Injectable } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Dbindexflds } from '../../../../../../../core/entities/dbindexflds.model';
import { Xmlfields } from '../../../../../../../core/entities/xmlfields.model';
import { Dbindices } from '../../../../../../../core/entities/dbindices.model';
import { DbindexfldsService } from '../../../../../../../core/repositories/dbindexflds.service';
import { InternalHomeService } from '../../../../../internal-home/internal-home.service';
import { SelectItem } from 'primeng/api';

@Injectable()
export class EditDialogsDbindexfldsService {

  dbindexflds: Dbindexflds = new Dbindexflds();
  originalDbindexflds: Dbindexflds = new Dbindexflds();
  xmlfields: Xmlfields[] = [];

  optionsXmlfields: SelectItem[] = [];
  optionsXmlfieldBase: SelectItem[] = [];

  alldbindexflds: Dbindexflds[] = [];

  changetitulo: boolean = false;
  disabledForm: boolean = false;
  disabledDbindex: boolean = false;

  dbindices: Dbindices = new Dbindices();

  constructor(private dbindexfldsService: DbindexfldsService,
              private internalHomeService: InternalHomeService) {}

  /**
  * Inicia el dialog
  * @param data Datos recibidos por el dialog
  */
  init(data: any): Observable<boolean> {
    console.log(data);
    this.dbindexflds = data.dbindexfld;
    this.changetitulo = data.titulochange;
    this.disabledForm = data.disabledDbindexfld;
    this.disabledDbindex = data.disabledDbindex;
    this.dbindices = data.dbindices;
    this.originalDbindexflds = _.cloneDeep(this.dbindexflds);
    if(this.dbindexflds.xmlfieldId.xmldefId != null){
        return forkJoin({
            valor0: this.dbindexfldsService.findAll(),
            valor1: this.internalHomeService.getbyIdXmlfields(this.dbindexflds.xmlfieldId.xmldefId)
        }).pipe(map(dataGroup => {
            this.alldbindexflds = dataGroup.valor0 as Dbindexflds[];
            this.xmlfields = dataGroup.valor1;

            this.optionsXmlfieldBase.push({value: null, label: ""});

            for(let i = 0; i < this.xmlfields.length; i++){
                this.optionsXmlfieldBase.push({value: this.xmlfields[i].code, label: this.xmlfields[i].code});
            }

            this.optionsXmlfields = this.optionsXmlfieldBase;

            if (Utils.noUndfAndNull(data.dbindexfld)) {
                this.dbindexflds = _.cloneDeep(data.dbindexfld);
            }

            this.optionsXmlfieldBase = [];

            return true;
          }));

    }else if(Utils.noUndfAndNull(this.dbindices)){
        return forkJoin({
            valor0: this.dbindexfldsService.findAll(),
            valor1: this.internalHomeService.getbyIdXmlfields(this.dbindices.dbmodelId.xmldefId.id)
        }).pipe(map(dataGroup => {
            this.alldbindexflds = dataGroup.valor0 as Dbindexflds[];
            this.xmlfields = dataGroup.valor1;

            this.optionsXmlfieldBase.push({value: null, label: ""});

            for(let i = 0; i < this.xmlfields.length; i++){
                this.optionsXmlfieldBase.push({value: this.xmlfields[i].code, label: this.xmlfields[i].code});
            }

            this.optionsXmlfields = this.optionsXmlfieldBase;
            this.dbindexflds.id = 0;
            if (Utils.noUndfAndNull(data.dbindexfld)) {
                this.dbindexflds = _.cloneDeep(data.dbindexfld);
            }

            this.optionsXmlfieldBase = [];

            return true;
          }));

    }else{
        return this.dbindexfldsService.findAll().pipe(map((result: Dbindexflds[]) => {
            this.alldbindexflds = result;
            if (Utils.noUndfAndNull(data.dbindexfld)) {
                this.dbindexflds = _.cloneDeep(data.dbindexfld);
            }
            return true;
        }));
    }
  }


  /**
  * @description
  * Guarda el dbindexfld
  */
  public guardar(): Observable<any> {
    console.log('guardar');
    /*entramos si venimos de dbindices*/
    if(this.dbindexflds.id === undefined){
        this.dbindexflds.id = 0;
        this.dbindexflds.dbindexId.id =  this.dbindices.id;
        for(let i = 0; i < this.xmlfields.length; i++){
            if(this.xmlfields[i].code === this.dbindexflds.xmlfieldId.code){
              this.dbindexflds.xmlfieldId.id = this.xmlfields[i].id;
            }
        }
        return this.dbindexfldsService.postDbindexfld(this.dbindexflds);
    /*entramos si venimos a editar desde dbindexflds*/
    }else if (Utils.noUndfAndNull(this.dbindexflds.id, "")) {

      /*comparamos el dbindexfld original con el modificado*/
      let compareDbindexfld = this.compare(this.dbindexflds, this.originalDbindexflds);

      /*añadimos el id nuevo mediante el code para cambiar el objeto*/
      for(let i = 0; i < this.xmlfields.length; i++){
          if(this.xmlfields[i].code === this.dbindexflds.xmlfieldId.code){
            this.dbindexflds.xmlfieldId.id = this.xmlfields[i].id;
          }
      }

      if(compareDbindexfld){
        return of(-1);
      }else{
        return this.dbindexfldsService.postDbindexfld(this.dbindexflds);
      }

    }else{
        /*entramos si venimos a crear desde dbindexflds*/
        return this.dbindexfldsService.postDbindexfld(this.dbindexflds);
    }
  }

  /**
  * @description
  * Comprueba si dos Dbindexflds son iguales.
  * @param datoX Dbindexfld 1
  * @param datoY Dbindexfld 2
  * @returns True si son iguales
  */
  public compare(itemX:Dbindexflds, itemY:Dbindexflds):boolean {
    //Ambos objetos están definidos y no son nulos
    if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

        if(itemX.id !== null ){
            if ((Utils.noUndfAndNull(itemX.xmlfieldId.code) && itemX.xmlfieldId.code !== "")
                && (Utils.noUndfAndNull(itemX.sequence) && String(itemX.sequence) !== ""))
                return false;
        }else{
            if ((Utils.noUndfAndNull(itemX.sequence) && String(itemX.sequence) !== "")
                && (Utils.noUndfAndNull(itemX.dbindexId.id) && String(itemX.dbindexId.id) !== "")
                && (Utils.noUndfAndNull(itemX.xmlfieldId.id) && String(itemX.xmlfieldId.id) !== ""))
                return false;
        }
    }
    //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
    else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
      return false;
    }
    return true;
  }

  /**
  * @description
  * Asigna a las propiedades del servicio sus valores por defecto
  */
  build() {
    this.dbindexflds = new Dbindexflds();
  }

}
